/** Dispatched on `window` for every reported error; the notification centre
 *  renders it. */
export const APP_ERROR_EVENT = "wp:notify-error";

export interface AppErrorDetail {
  title: string;
  body: string;
}

/** Surface an error to the user without knowing who renders it. */
export function reportAppError(error: unknown, title = "Something went wrong"): void {
  const body = error instanceof Error ? error.message : title;
  window.dispatchEvent(
    new CustomEvent<AppErrorDetail>(APP_ERROR_EVENT, { detail: { title, body } }),
  );
}
